import React, {Component} from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';

import DialogLogin from './DialogLogin';

export default class Event extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isDialogLoginOpen: false,         
        }
        
    }

// Iniciální načtení dat
    componentDidMount() {   
    }

    // Dialogy
    
    handleDialogLoginClose = () => {
        this.setState({isDialogLoginOpen: false});  
        this.props.onRefresh();        
      };
  
    render() {
        return (
            <div >
                {/* dialogy */}
                <DialogLogin 
                    myId = {this.props.myId} 
                    myTime={this.props.myTime} 
                    myPerson = {this.props.myPerson} 
                    myValid = {this.props.myValid}

                    myopen={this.state.isDialogLoginOpen} 
                    onClickClose={() => this.handleDialogLoginClose()} 
                    
                />

                
                <Grid justify="center" container spacing={0}>
                
                <Grid item xs={0} sm={1} md={3}></Grid>
                
                    <Grid item xs={4} sm={3} md={2}>
                    <Paper className="event">
                
                        {<b>{this.props.myTime}</b>}                            
                        </Paper>
                
                    </Grid>
                
                    <Grid item xs={8} sm={7} md={4}>
                        
                        {<b>{ this.props.myValid && 
                        
                        <Paper className="event">
                        {this.props.myPerson}</Paper>}</b>}
                        
                        { ! this.props.myValid &&
                        
                        <Button className="button" size="large" color="primary" variant="contained" 
                        onClick={() => {this.setState({isDialogLoginOpen: true});} } 
                        >
                        Přihlásit
                        </Button>
                        }                        
                    </Grid>
                
                    <Grid item xs={0} sm={1} md={3}></Grid> 
                    
                </Grid>

            </div>
        )
    }

}